import { MutationHookOptions, useMutation } from '@apollo/client';

import { ADD_RECAP } from './mutations';

export const useAddRecapAnswer = (options?: MutationHookOptions) => useMutation(ADD_RECAP, options);
